// /guide — thank-you / redirect page hit by HubSpot's form-success redirect.
//
// Why a real page (not a Firebase server-side redirect):
// - We need to fire conversion events (Lead on Meta + generate_lead on GA4) AFTER
//   the form was successfully submitted. Server-side redirects would skip our JS.
// - On this page we have full control: fire events synchronously, then redirect
//   to the actual guide PDF on Google Drive after a short grace period so beacons
//   reach Meta/Google reliably.
import React from 'react';
import { LogoMark } from './LogoMark.jsx';
import { trackLead } from '../lib/tracking.js';

const GUIDE_PDF_URL = 'https://drive.google.com/file/d/1nKZDym_ry04q5JdB20Z0oRUuSjJgbg-9/view?usp=sharing';
const REDIRECT_DELAY_MS = 1500;

export default function GuidePage() {
  const [secondsLeft, setSecondsLeft] = React.useState(Math.ceil(REDIRECT_DELAY_MS / 1000));

  React.useEffect(() => {
    // Fire conversion events first.
    trackLead({ method: 'guide_form' });

    // Countdown UI (purely cosmetic).
    const tick = setInterval(() => {
      setSecondsLeft((s) => Math.max(0, s - 1));
    }, 1000);

    // Redirect after the grace period — replace() so back-button skips this page.
    const t = setTimeout(() => {
      window.location.replace(GUIDE_PDF_URL);
    }, REDIRECT_DELAY_MS);

    return () => { clearTimeout(t); clearInterval(tick); };
  }, []);

  return (
    <main className="guide-page">
      <div className="guide-page-card">
        <div className="guide-page-mark"><LogoMark size={56} /></div>
        <div className="guide-page-eyebrow">App Academy Guide</div>
        <h1 className="guide-page-title">
          Danke! Dein Guide wird in <span className="guide-page-countdown">{secondsLeft}</span>s geöffnet.
        </h1>
        <p className="guide-page-body">
          Wir öffnen den Guide gerade in einem neuen Tab. Du bekommst zusätzlich eine E-Mail mit dem direkten Download-Link an deine angegebene Adresse.
        </p>
        <div className="guide-page-spinner-wrap" aria-hidden="true">
          <div className="guide-page-spinner" />
        </div>
        <a className="guide-page-fallback" href={GUIDE_PDF_URL} target="_blank" rel="noreferrer">
          Falls die Weiterleitung nicht funktioniert: Guide manuell öffnen
        </a>
        <a className="guide-page-back" href="/">← Zurück zur Startseite</a>
      </div>
    </main>
  );
}
